export default {
  'transaction.label.downloadStatement': 'Statement',
  'transaction.label.downloadStatement.title': 'Download account statement',
  'transaction.label.accountStatement': 'Account statement',
  'transaction.text.downloadAccountStatement':
    'You can download your account statement',
  'transaction.error.invalidDatePeriod': '* Invalid date period.',
  'transaction.error.downloadStatement': 'Error while downloading statement.',
};
